import React, { useState } from "react";
import {
	CustomTableRow,
	CustomTableCell,
	CustomButton,
	CustomIconButton,
	CustomDialog,
	icon,
} from "../../../../common/components";
import { translate } from "../../../../common/providers";
import { ApiService } from "../../../../api";
import CoverageDocumentService from "../../../../api/services/operation/coverage-document-service";
import styles from "../../../project-phases/components/phase-row/PhaseRow.module.css";

const DeliverableRow = ({ deliverable, onDelete, onOpenCategories, onOpenEdit }) => {
	const [confirmationDialog, setConfirmationDialog] = useState({
		open: false,
		type: null,
		title: "",
		message: "",
		onConfirm: null,
	});
	const [isDeleting, setIsDeleting] = useState(false);

	const handleEdit = () => {
		if (onOpenEdit) {
			onOpenEdit(deliverable);
		}
	};

	const showConfirmationDialog = (type, onConfirm) => {
		let title;
		let message;

		if (type === "delete") {
			title = translate("deliverables-list.actions.confirm-delete-title", "Supprimer le livrable ?");
			message = translate(
				"deliverables-list.actions.confirm-delete-message",
				"Voulez-vous vraiment supprimer ce livrable ?"
			);
		} else {
			title = translate("common:btn.confirm");
			message = "";
		}

		setConfirmationDialog({
			open: true,
			type,
			title,
			message,
			onConfirm,
		});
	};

	const closeConfirmationDialog = () => {
		setConfirmationDialog({
			open: false,
			type: null,
			title: "",
			message: "",
			onConfirm: null,
		});
	};

	const handleConfirmAction = () => {
		if (typeof confirmationDialog.onConfirm === "function") {
			confirmationDialog.onConfirm();
		}
		closeConfirmationDialog();
	};

	const handleDelete = () => {
		showConfirmationDialog("delete", () => {
			setIsDeleting(true);
			const cancelTokenSource = ApiService.getCancelTokenSource();
			CoverageDocumentService.delete({ docId: deliverable.id }, cancelTokenSource.token)
				.then(() => {
					onDelete(deliverable);
				})
				.catch((error) => {
					console.error("Error deleting deliverable:", error);
				})
				.finally(() => {
					setIsDeleting(false);
				});
		});
	};

	return (
		<>
			<CustomTableRow hover>
				<CustomTableCell data-testid={`deliverable.name.${deliverable.name}`}>
					{deliverable.name}
				</CustomTableCell>
				<CustomTableCell>{deliverable.ref}</CustomTableCell>
				<CustomTableCell>{deliverable.type?.name || deliverable.type}</CustomTableCell>
				<CustomTableCell>{deliverable.format?.name || deliverable.format}</CustomTableCell>
				<CustomTableCell>{deliverable.phase?.name || deliverable.phaseName}</CustomTableCell>
				<CustomTableCell>{deliverable.owner?.displayName || deliverable.ownerName}</CustomTableCell>
				<CustomTableCell>
					<CustomButton variant="outlined" onClick={() => onOpenCategories(deliverable)}>
						{deliverable.count || "-"}
					</CustomButton>
				</CustomTableCell>
				<CustomTableCell align="right">
					<div className={styles.actionsContainer}>
						<CustomIconButton
							className={styles.actionButton}
							data-testid={`deliverable.edit.${deliverable.id}`}
							icon={icon.faPen}
							tooltip={translate("deliverables-list.actions.edit")}
							variant="outlined"
							onClick={handleEdit}
						/>
						<CustomIconButton
							className={styles.actionButton}
							data-testid={`deliverable.delete.${deliverable.id}`}
							disabled={isDeleting}
							icon={icon.faTrash}
							tooltip={translate("deliverables-list.actions.delete")}
							variant="outlined"
							onClick={handleDelete}
						/>
					</div>
				</CustomTableCell>
			</CustomTableRow>
			<CustomDialog
				cancelLabel={translate("common:btn.cancel")}
				iconColor="var(--red-500)"
				iconModel={icon.faExclamationTriangle}
				open={confirmationDialog.open}
				submitColor="destructive"
				submitDisabled={isDeleting}
				submitLabel={
					isDeleting ? translate("deliverables-list.actions.deleting") : translate("common:btn.confirm")
				}
				subTitle={confirmationDialog.message}
				title={confirmationDialog.title}
				onClose={() => !isDeleting && closeConfirmationDialog()}
				onSubmit={handleConfirmAction}
			/>
		</>
	);
};

export default DeliverableRow;
